import React from 'react'
import './Loader.css'

export const Loader = ({loading, extraClasses}) => <div className={loading ? `loader ${extraClasses ? extraClasses : ''}` : 'loader-hidden'}>Sæki gögn...</div>

export default Loader



// WEBPACK FOOTER //
// ./src/Search/Loader.js